import { useAppTranslation } from "@/utils";
import { Button, Divider, Flex, LegacyCard, Modal, Typography } from "@payping/web-components";
import { FC, useState } from "react";

interface RefundCustomerChequeProps {
  customerFullName: string;
  customerPhone: string;
  customerAddress: string;
  customerPostalCode: string;
}
const BnplMerchantGetOrderDetailRefundCustomerCheque: FC<RefundCustomerChequeProps> = ({
  customerAddress,
  customerFullName,
  customerPhone,
  customerPostalCode,
}) => {
  const { t } = useAppTranslation();
  const items = t("shop.bnpl.orderDetails.refundCustomerCheque.list.items", { returnObjects: true }) as string[];

  const [showModal, setShowModal] = useState(false);
  return (
    <>
      <LegacyCard.Ant size="small">
        <Flex vertical gap={"middle"} className="tw:w-full">
          <Typography.Title level={5} className="tw:m-0!">
            {t("shop.bnpl.orderDetails.refundCustomerCheque.title")}
          </Typography.Title>
          <Flex vertical className="tw:m-0!">
            <Typography.Text>{t("shop.bnpl.orderDetails.refundCustomerCheque.description")}</Typography.Text>
            <Typography.Text>{t("shop.bnpl.orderDetails.refundCustomerCheque.list.title")}</Typography.Text>
            <ul className="tw:m-0! tw:p-0! tw:pr-[20px]!">
              {items.map((item, index) => (
                <li className="tw:m-0! tw:p-0!" key={index}>
                  <Typography.Text>{item}</Typography.Text>
                </li>
              ))}
            </ul>
          </Flex>
          <div>
            <Button
              onClick={() => {
                setShowModal(true);
              }}
              className="tw:m-0!"
              variant="link"
              color="primary"
            >
              {t("shop.bnpl.orderDetails.refundCustomerCheque.customerInfo")}
            </Button>
          </div>
        </Flex>
      </LegacyCard.Ant>
      {showModal ? (
        <Modal
          open={showModal}
          onCancel={() => {
            setShowModal(false);
          }}
          title={t("shop.bnpl.orderDetails.refundCustomerCheque.customerInfo")}
          footer={
            <Flex>
              <Button
                onClick={() => {
                  setShowModal(false);
                }}
                color="primary"
                variant="solid"
              >
                {t("common.understood")}
              </Button>
            </Flex>
          }
        >
          <LegacyCard.Ant size="small">
            <Flex vertical className="tw:w-full" gap={"small"}>
              <Flex vertical className="tw:w-full" gap={"4px"}>
                <Typography.Text type="secondary">{t("common.firstName")}</Typography.Text>
                <Typography.Text>{customerFullName}</Typography.Text>
              </Flex>
              <Divider className="tw:m-0!" />
              <Flex vertical className="tw:w-full" gap={"4px"}>
                <Typography.Text type="secondary">{t("common.mobileNumber")}</Typography.Text>
                <Typography.Text>{customerPhone}</Typography.Text>
              </Flex>
              <Divider className="tw:m-0!" />
              <Flex vertical className="tw:w-full" gap={"4px"}>
                <Typography.Text type="secondary">{t("common.postalCode")}</Typography.Text>
                <Typography.Text>{customerPostalCode}</Typography.Text>
              </Flex>
              <Divider className="tw:m-0!" />
              <Flex vertical className="tw:w-full" gap={"4px"}>
                <Typography.Text type="secondary">{t("common.address")}</Typography.Text>
                <Typography.Text>{customerAddress}</Typography.Text>
              </Flex>
            </Flex>
          </LegacyCard.Ant>
        </Modal>
      ) : null}
    </>
  );
};

export default BnplMerchantGetOrderDetailRefundCustomerCheque;
